import { Navigate, useLocation } from 'react-router-dom';
import useShallowEqualSelector from 'hooks/useShallowEqualSelector.js';
import './index.scss';

const RequireShop = ({ redirectTo = '/operator/select-station', children }) => {
    const from = useLocation();

    const shopId = useShallowEqualSelector(state => state.operatorHome.shopId);

    if(!shopId) return <Navigate to={redirectTo} state={{ from }} replace />;
    else return children;
};

export default RequireShop;
